var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icona_aggiungi",
    "data-name": "icona aggiungi",
    d: "M23.969,15.969H17.961V9.961a1,1,0,0,0-1.992,0v6.008H9.961a1,1,0,0,0,0,1.992h6.008v6.008a1,1,0,1,0,1.992,0V17.961h6.008a1,1,0,0,0,0-1.992Z",
    transform: "translate(-8.965 -8.965)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.db0220cf6e73a44e6f92cca70777cbad.svg";
export { ForwardRef as ReactComponent };